import React, { useState, useEffect } from "react";
import {
  ObtieneCadenaComercialCliente,
  ObtieneDatosUsuarioCadenaComercial,
} from "../repository";
import Swal from "sweetalert";

const Header = (props) => {
  const [user, setUser] = useState([]);
  const [isCadenaComercial, setIsCadenaComercial] = useState(0);
  const [cadenaComercial, setCadenaComercial] = useState([]);

  const validaMultiCuentas = () => {
    var user = JSON.parse(sessionStorage.getItem("usuario"));
    // console.log(user[0]);
    console.log(user[0].Nombre + " ---" + user[0].usuario);
    ObtieneCadenaComercialCliente(user[0].usuario).then((response) => {
      if (response.data.length > 0) {
        var items = response.data.map((item) => {
          return {
            value: item.UserName,
            key: item.idCliente,
            text: item.UserName + " - " + item.Nombre + " - " + item.Cedis,
          };
        });
        setIsCadenaComercial(1);
        setCadenaComercial(items);
      }
    });
  };

  const handleComboChange = (event) => {
    if (event.target.name === "idUsuario") {
      //   console.log(event.target.value + " ");
      if (event.target.value === "0") {
        Swal("Aviso", "Por favor seleccione un cliente.", "info");
      } else {
        sessionStorage.clear();
        ObtieneDatosUsuarioCadenaComercial(event.target.value).then(
          (response) => {
            //Usuario
            sessionStorage.clear();
            // sessionStorage.removeItem("usuario");
            sessionStorage.setItem("usuario", JSON.stringify(response.data));
            //Token
            sessionStorage.setItem("x-access-token", response.data.token);
            //Token expira en 12 horas
            sessionStorage.setItem(
              "x-access-token-expiration",
              Date.now() + 12 * 60 * 60 * 1000
            );
            // console.log(response);

            window.location = "/home";
          }
        );
      }
    }
  };

  useEffect(() => {
    setUser(JSON.parse(sessionStorage.getItem("usuario")));
    validaMultiCuentas();
  }, []);

  return (
    <header id="main-header">
      <div className="container">
        <div className={props.class1}>
          <div className={props.class2}>
            <h4 className="mt-2">
              <i className={props.class3}></i>
              &nbsp;{props.title}
            </h4>
          </div>
          <div className="col-md-6 py-1">
            <div className="float-right"></div>
          </div>
        </div>
        <div className="row bg-light py-1">
          <div className="col-md-12">
            <div className="float-right">
              {isCadenaComercial === 1 && (
                <div className="row  align-items-center">
                  <div className="col-xs">           
                      <i className="fas fa-user"></i>
                  </div>
                  <div className="col">
                    <select
                      className="form-control"
                      name="idUsuario"
                      key="idusuario"
                      size="1"
                      value={user[0].usuario}
                      onChange={handleComboChange}
                    >
                      {cadenaComercial.map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.text}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
              {isCadenaComercial === 0 &&
                (user[0]
                  ? user[0].Nombre.length > 30
                    ? user[0].Nombre.substring(0, 250)
                    : user[0].Nombre
                  : "")}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
